import { Component } from '@angular/core';
import { Developer } from 'src/app/shared/models/developer.model';
import { developers } from './about-us-page.metadata';
import { developers2024 } from './about-us-page.metadata';
import { developer2025 } from './about-us-page.metadata';
import { developer2026 } from './about-us-page.metadata';
import { ButtonDirective } from 'primeng/button';

import { DeveloperCardComponent } from '../developer-card/developer-card.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-us-page',
  templateUrl: './about-us-page.component.html',
  styleUrls: ['./about-us-page.component.scss'],
  standalone: true,
  imports: [ButtonDirective, DeveloperCardComponent],
})
export class AboutUsPageComponent {
  developers: Developer[] = developers;
  developers2024: Developer[] = developers2024;
  developer2025: Developer[] = developer2025;
  developer2026: Developer[] = developer2026;
  bannerImageName = '../../../assets/images/2024_team_photo.jpg';
  gridColumns = 3;

  environment = environment;
}
